/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListCrmProductDto } from '../models/api-response-list-crm-product-dto';
import { downloadProductImage } from '../fn/crm-product-api/download-product-image';
import { DownloadProductImage$Params } from '../fn/crm-product-api/download-product-image';
import { downloadProductImage1 } from '../fn/crm-product-api/download-product-image-1';
import { DownloadProductImage1$Params } from '../fn/crm-product-api/download-product-image-1';
import { getAllProducts } from '../fn/crm-product-api/get-all-products';
import { GetAllProducts$Params } from '../fn/crm-product-api/get-all-products';

@Injectable({ providedIn: 'root' })
export class CrmProductApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllProducts()` */
  static readonly GetAllProductsPath = '/v1/api/ui/zoho-products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllProducts$Response(params: GetAllProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListCrmProductDto>> {
    return getAllProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllProducts(params: GetAllProducts$Params, context?: HttpContext): Observable<ApiResponseListCrmProductDto> {
    return this.getAllProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListCrmProductDto>): ApiResponseListCrmProductDto => r.body)
    );
  }

  /** Path part for operation `downloadProductImage()` */
  static readonly DownloadProductImagePath = '/v1/api/ui/zoho-products/{productId}/image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadProductImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProductImage$Response(params: DownloadProductImage$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return downloadProductImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadProductImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProductImage(params: DownloadProductImage$Params, context?: HttpContext): Observable<string> {
    return this.downloadProductImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `downloadProductImage1()` */
  static readonly DownloadProductImage1Path = '/v1/api/ui/zoho-products/{productId}/image/{ignored}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadProductImage1()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProductImage1$Response(params: DownloadProductImage1$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return downloadProductImage1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadProductImage1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProductImage1(params: DownloadProductImage1$Params, context?: HttpContext): Observable<string> {
    return this.downloadProductImage1$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
